import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToPlay = (
    play$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    play$
        .subscribe(() => playbackStore.actions.play());

export default subscribeToPlay;